import type { MaybeRefOrGetter } from 'vue';
import type { ResolvedMonospaceCollection } from '#layers/data-model/types/schema/resolved-schema';
import type { CollectionRead } from '#layers/data-model/utils/schema/read-output';
import { computed, toValue } from 'vue';
import { useWorkspaceSchemaStore } from '#layers/data-model/stores/workspace-schema';
import { resolveCollectionDisplayTemplate } from '#layers/data-model/utils/display-template';

export function useCollectionDisplayTemplate(collection: MaybeRefOrGetter<ResolvedMonospaceCollection>, read: MaybeRefOrGetter<CollectionRead>) {
	const workspaceSchema = useWorkspaceSchemaStore();
	return computed(() => resolveCollectionDisplayTemplate(toValue(collection), toValue(read), workspaceSchema.querySchema));
}
